import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Supabase authentication is not configured.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // OAuth callbacks are completed explicitly on the login page. This avoids
    // browser-dependent races where the PKCE code reaches /login but is never
    // exchanged for a persisted session.
    detectSessionInUrl: false,
    flowType: 'pkce',
  },
});
